export const styleV3_1 = {
  reactSelect: {
    borderColor: '#99999990',
    borderRadius: 7,
    padding: '2px 6px'
  }
}